// extracted by mini-css-extract-plugin
export default {"link_ig":"QuickSearch__link_ig--ig-bsOuY","image_ig":"QuickSearch__image_ig--ig-tspaF","image-container_ig":"QuickSearch__image-container_ig--ig-YF9cW"};